<!--
    Styles
-->

<style>

    #app > .l-footer {
        height: 32px;
        padding: 0 10px;
        background: #333333;
    }
    #app > .l-footer a:before {
        content: '\25B6';
        margin-right: 5px;
    }

</style>



<!--
    Template
-->

<template>
    <footer class="l-footer u-row cl-white">
        <p class="t9 u-flex">Copyright © Open Room, Inc. All Rights Reserved.</p>
        <a class="t10" target="_blank" href="https://openrm.co.jp/company.html">運営会社</a>
    </footer>
</template>



<!--
    Scripts
-->

<script>

    export default {

    }

</script>
